export enum IOrgChallengeTargetResultEnum {
  count = 'OrgChallengeTargetResult.count',
  userCount = 'OrgChallengeTargetResult.userCount',
  dayCount = 'OrgChallengeTargetResult.dayCount',
  successTotal = 'OrgChallengeTargetResult.successtotal',
  failTotal = 'OrgChallengeTargetResult.failtotal',
  accountId = 'OrgChallengeTargetResult.accountid',
  userId = 'OrgChallengeTargetResult.userid',
  createdBy = 'OrgChallengeTargetResult.createdby',
  createdAt = 'OrgChallengeTargetResult.createdat',
  updatedBy = 'OrgChallengeTargetResult.updatedby',
  updatedAt = 'OrgChallengeTargetResult.updatedat',
  challengeId = 'OrgChallengeTargetResult.challengeid',
  challengeTargetId = 'OrgChallengeTargetResult.challengetargetid',
  targetValue = 'OrgChallengeTargetResult.targetvalue',
  result = 'OrgChallengeTargetResult.result',
  localDate = 'OrgChallengeTargetResult.localdate',
  weekdayIndex = 'OrgChallengeTargetResult.weekdayindex',
  DepartmentId = 'OrgChallengeTargetResult.departmentid',
}

export enum IOrgChallengeTargetResultSegmentsEnum {
  monday = 'OrgChallengeTargetResult.monday',
  tuesday = 'OrgChallengeTargetResult.tuesday',
  wednesday = 'OrgChallengeTargetResult.wednesday',
  thursday = 'OrgChallengeTargetResult.thursday',
  friday = 'OrgChallengeTargetResult.friday',
  saturday = 'OrgChallengeTargetResult.saturday',
  sunday = 'OrgChallengeTargetResult.sunday',
}
